export default __webpack_public_path__ + "static/Harvester4-587204c53d50478e53bdc6330163c301.jpg";